module.exports = __webpack_public_path__ + "static/media/team8.e2b17000.png";